module.exports = __webpack_public_path__ + "img/dr-banr.ad0f41c7.png";